import * as React from 'react';
import classNames from 'classnames';

import * as style from './HeaderCell.css';
import { getCellStyle } from '../../../../utils/table';

export interface IHeaderCellProps {
  position?: number;
  published?: boolean;
  sticky?: boolean;
}

export const HeaderCell = (props: React.PropsWithChildren<IHeaderCellProps>) => {
  const { children, position, published = true, sticky = false } = props;
  const styles = React.useMemo(() => getCellStyle(position), [position]);

  return (
    <div
      style={styles}
      className={classNames(
        style['head-cell'],
        sticky && style['head-cell--sticky'],
        !published && style['head-cell--unpublished'],
      )}
    >
      {children}
    </div>
  );
};
